import { UXComponentType } from '../UXComponentRenderer/uxComponent.types'
import momentTZ from 'moment-timezone'
import { Cutoff } from 'src/redux-api-bridge/metadata/actions'

export const formatCutoffText = (
  cutoff: Cutoff,
  displayDate: string
): string => {
  if (!cutoff || !cutoff.time || !cutoff.userTimeZone) {
    return 'the cutoff time'
  }

  const cutoffMoment = momentTZ(cutoff.time).tz(cutoff.userTimeZone)
  const formattedTime = cutoffMoment.format('h a')
  const formattedDate = cutoffMoment.format('MMM. D')

  return `${formattedTime} ${cutoff.tzShortName} on ${formattedDate}`
}

export const createSkipDeliverySubtitle = (
  cutoff: Cutoff,
  displayDate: string
): string => {
  const cutoffText = formatCutoffText(cutoff, displayDate)
  return `You can still unskip and order before ${cutoffText}.`
}

export const skipDeliveryMockData = {
  leftIcon: {
    type: UXComponentType.Icon,
    version: 1,
    attributes: {
      asset: 'INFO_SKIPPED'
    }
  },
  title: {
    type: UXComponentType.Text,
    version: 1,
    attributes: {
      value: "You've skipped this delivery",
      style: 'HighlightSmall',
      color: '#9B4D00'
    }
  },
  subtitle: {
    type: UXComponentType.Text,
    version: 1,
    attributes: {
      value: 'You can still unskip and order before 12 pm ET on Nov. 10.',
      style: 'BaseSmall',
      color: '#564F61'
    }
  },
  button: {
    type: UXComponentType.Button,
    version: 1,
    attributes: {
      type: 'PRIMARY',
      size: 'SMALL',
      label: {
        type: 'LABEL',
        version: 2,
        attributes: {
          text: {
            type: UXComponentType.Text,
            version: 1,
            attributes: {
              value: 'Unskip delivery',
              style: 'UtilitiesSmallHeavy',
              color: '#3E354A'
            }
          }
        }
      },
      actionsEnabled: true,
      actions: {
        onClick: []
      }
    }
  }
} as const
